// import useSWR from 'swr';
// import { fetchAdminInfo } from '../../../../api/ApiEntreprise';
// import { AdminInfo } from '../../DashboarEntreprise/Ttype';

// export const useAdminInfo = () => {
//   const companyId = localStorage.getItem('company');

//   const { data, error, mutate } = useSWR<AdminInfo>(
//     companyId ? `/admin/info/` : null, // Ne pas faire la requête si companyId est null
//     () => fetchAdminInfo(),
//     {
//       revalidateOnFocus: false,
//       shouldRetryOnError: false,
//     }
//   );

//   return {
//     adminInfo: data,
//     isLoading: !error && !data,
//     isError: error,
//     mutateAdminInfo: mutate,
//   };
// };




import useSWR from 'swr';
import { fetchAdminInfo } from '../../../../api/ApiEntreprise';
import { AdminInfo } from '../../DashboarEntreprise/Ttype';

export const useAdminInfo = () => {
  // const companyId = localStorage.getItem('company');


  const { data, error, mutate } = useSWR<AdminInfo>(
    `/admin/info/` ,
    () => fetchAdminInfo(),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  // console.log('useAdminInfo data:', data);
  
  return {
    adminInfo: data,
    isLoading: !error && !data,
    isError: error,
    mutateAdminInfo: mutate,
  };
};